import React from "react";
import { graphql, StaticQuery } from "gatsby";
import MeetingCard from "../utility/meetingCard";
import Prose from "../utility/prose";

class BoardMeeting extends React.Component {
    constructor(props) {
        super(props)
        this.yearRange = this.getYearRange(this.props.meetings)
        this.state = {
            meetingYear: this.yearRange.max,
        }
        this.YearNav = this.YearNav.bind(this)
        this.setYear = this.setYear.bind(this)
    }

    getYearRange(array) {
        let min = new Date(array[0].meeting_time).getFullYear()
        let max = 0

        array.map( x => {
        let year = new Date(x.meeting_time).getFullYear()
        min = year < min ? year : min
        max = year > max ? year : max
        })

        return { min: min, max: max }
    }

    setYear(year) {
        this.setState({ meetingYear: year})
    }

    YearNav({set}) {
        let yearset = [ ];

        for(let i = this.yearRange.max; i >= this.yearRange.min; i--) {
            yearset.push(i)
        }

        let inactive = `bg-neutral-200 dark:bg-neutral-600 px-4 py-1 rounded-full mr-2 mb-2 last:mr-0`
        let active = `bg-green-300 dark:bg-green-600 px-4 py-1 rounded-full mr-2 mb-2 last:mr-0`

        return(<div className="text-center mb-12">
            <h2>Select Year</h2>
            <div className="buttons is-centered">
            {yearset.map(year => (
            <button 
                onClick={() => this.setYear(year)}
                className={this.state.meetingYear == year ? active : inactive}>
                {year}
            </button>
            ))}
            </div>
        </div>)
    }

    render() {
        return (
            <Prose>
            <div className="has-text-centered">
                <this.YearNav set={this.state.navSet} />
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {this.props.meetings
                        .filter(meeting => new Date(meeting.meeting_time).getFullYear() === this.state.meetingYear )
                        .map(meeting =>(
                        <MeetingCard 
                            key={meeting.id}
                            meeting={meeting}
                        />
                    ))}
                </div>
            </div>
            </Prose>
        )
    }
}

export default () => (
    <StaticQuery query={graphql`
        query {
            allStrapiBoardMeeting(sort: {meeting_time: DESC}) {
                nodes {
                    id
                    meeting_type
                    meeting_time
                    agenda {
                        localFile {
                        publicURL
                        prettySize
                        }
                    }
                    minutes {
                        localFile {
                        publicURL
                        prettySize
                        }
                    }
                    attachments {
                        id
                        title
                        file {
                        localFile {
                            publicURL
                            prettySize
                        }
                        }
                    }
                    video_url
                }
            }
        }
    `}
    render={(data) => (
        <BoardMeeting meetings={data.allStrapiBoardMeeting.nodes} />
    )} 
    />
)
